import { render } from "./VideoFallback.vue?vue&type=template&id=5f8b7f64&scoped=true"
import script from "./VideoFallback.vue?vue&type=script&lang=js"
export * from "./VideoFallback.vue?vue&type=script&lang=js"

import "./VideoFallback.vue?vue&type=style&index=0&id=5f8b7f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8b7f64"]])

export default __exports__